// removed by extract-text-webpack-plugin
module.exports = {"MainContainer":"draftslist__MainContainer__3TeUl","ListSection":"draftslist__ListSection__1RyL5"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/DraftsList/draftslist.css
// module id = 160
// module chunks = 0